import type { Connection } from "@shared/types/connection"
import { onSnapshot, query } from "firebase/firestore"
import { httpsCallable } from "firebase/functions"
import { useCallback, useEffect, useState } from "react"

import { functions } from "../firebase"
import { connectionsRef } from "../firestore/db"
import { useAuth } from "./useAuth"

const disconnectConnectionFn = httpsCallable<{ connectionId: string }, void>(
  functions,
  "disconnectConnection",
)

export function useConnections() {
  const { user } = useAuth()
  const [connections, setConnections] = useState<Connection[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) {
      setConnections([])
      setLoading(false)
      return
    }

    const unsubscribe = onSnapshot(
      query(connectionsRef(user.uid)),
      (snapshot) => {
        // doc.data() is already typed as Connection — oid injected by the converter
        setConnections(snapshot.docs.map((doc) => doc.data()))
        setLoading(false)
      },
    )

    return unsubscribe
  }, [user])

  const disconnect = useCallback(async (connectionId: string) => {
    await disconnectConnectionFn({ connectionId })
  }, [])

  return { connections, loading, disconnect }
}
